import { cn } from '../../../lib/utils';
import type { AvatarProps, AvatarSize } from './types';

const SIZE: Record<AvatarSize, string> = {
  sm: 'size-8 text-base',
  md: 'size-10 text-xl',
  xl: 'size-20 text-[40px]',
};

export function Avatar({ letter, imageUrl, alt, size = 'md', className }: AvatarProps) {
  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-avatar',
        SIZE[size],
        className,
      )}
    >
      {imageUrl ? (
        <img src={imageUrl} alt={alt ?? ''} className="size-full object-cover" />
      ) : letter ? (
        <span className="leading-none text-avatar-foreground">{letter}</span>
      ) : null}
    </div>
  );
}
